/**
 *
 * @module creditCardType
 *
 */

/* eslint new-cap: 'off' */

/**
 *
 * @typedef CreditCardType
 * @type {Object}
 * @desc An enumeration of accepted credit cards.
 *
 * @property {Object} Visa
 * @property {Object} MasterCard
 * @property {Object} Amex
 * @property {Object} Discover
 *
 */

/**
 *
 * @enum
 * @type {CreditCardType}
 *
 */
export default {
    /**
     *
     * @access public
     * @type {Object}
     *
     */
    Visa: { id: 2, name: 'VISA' },
    /**
     *
     * @access public
     * @type {Object}
     *
     */
    Mastercard: { id: 4, name: 'MASTERCARD' },
    /**
     *
     * @access public
     * @type {Object}
     *
     */
    Discover: { id: 8, name: 'DISCOVER' },
    /**
     *
     * @access public
     * @type {Object}
     *
     */
    Amex: { id: 1, name: 'AMEX' }
};



// WEBPACK FOOTER //
// ./src/commerce/creditCardType.js